// src/pages/ExamStart.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({ baseURL: '/api/student' });

export default function ExamStart() {
    const { id } = useParams(); // id = term_id
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [term, setTerm] = useState(null);
    const [serverNow, setServerNow] = useState(() => new Date());

    useEffect(() => {
        const token = localStorage.getItem('token');
        api.get(`/egzamin/${id}`, { headers: { Authorization: `Bearer ${token}` }})
            .then(res => {
                setTerm(res.data);
                // spróbuj użyć czasu serwera z nagłówka Date; fallback: klient
                const serverDateHeader = res.headers?.date || res.headers?.Date;
                setServerNow(serverDateHeader ? new Date(serverDateHeader) : new Date());
            })
            .catch(e => setErr(e?.response?.data?.blad || 'Błąd pobierania danych egzaminu'))
            .finally(() => setLoading(false));
    }, [id]);

    // żywe odliczanie (aktualizacja co 1s względem serverNow)
    const [tick, setTick] = useState(0);
    useEffect(() => {
        const t = setInterval(() => setTick(t => t + 1), 1000);
        return () => clearInterval(t);
    }, []);

    const canStart = useMemo(() => {
        if (!term) return false;
        const startAt = new Date(term.exam_datetime);
        const now = new Date(serverNow.getTime() + tick * 1000);
        return now >= startAt;
    }, [term, serverNow, tick]);

    const countdown = useMemo(() => {
        if (!term) return null;
        const startAt = new Date(term.exam_datetime);
        const now = new Date(serverNow.getTime() + tick * 1000);
        const ms = Math.max(0, startAt - now);
        const s = Math.floor(ms / 1000);
        const hh = String(Math.floor(s / 3600)).padStart(2, '0');
        const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
        const ss = String(s % 60).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
    }, [term, serverNow, tick]);

    const onStart = async () => {
        // Na razie tylko przejście dalej; gdy dodamy tworzenie attemptu,
        // tutaj zrobimy POST /api/student/exams/:termId/start i przejdziemy z attemptId.
        navigate(`/egzamin/${id}/trwa`);
    };

    if (loading) return <div style={{ padding: 16 }}>Ładowanie…</div>;
    if (err) return <div style={{ padding: 16, color: 'crimson' }}>{err}</div>;
    if (!term) return null;

    const startLocal = new Intl.DateTimeFormat('pl-PL', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(term.exam_datetime));

    return (
        <div style={{ padding: 16, maxWidth: 840, marginTop:50 }}>
            <h1 style={{ marginBottom: 4 }}>{term.title}</h1>
            <div style={{ color: '#6b7280', marginBottom: 16 }}>
                {term.group_name} • start: {startLocal} • czas trwania: {term.exam_duration} min
            </div>

            <section style={{
                border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, background: 'white', marginBottom: 16
            }}>
                <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Instrukcja</h2>
                <ul style={{ color: '#374151', lineHeight: 1.6 }}>
                    <li>Przygotuj ciche miejsce i stabilne łącze.</li>
                    <li>Nie odświeżaj strony w trakcie egzaminu.</li>
                    <li>Nie opuszczaj okna przeglądarki (monitorujemy focus).</li>
                    <li>Wyłącz komunikatory i powiadomienia.</li>
                    <li>(Tu wstawimy Twoje szczegółowe uwagi później.)</li>
                </ul>
            </section>

            {!canStart ? (
                <div style={{
                    border: '1px dashed #d1d5db', borderRadius: 12, padding: 16, marginBottom: 12, color: '#6b7280'
                }}>
                    Egzamin jeszcze się nie rozpoczął. Do startu pozostało: <strong>{countdown}</strong>
                </div>
            ) : null}

            <button
                onClick={onStart}
                disabled={!canStart}
                style={{
                    opacity: canStart ? 1 : 0.6,
                    cursor: canStart ? 'pointer' : 'not-allowed',
                    background: '#111827',
                    color: 'white',
                    padding: '10px 16px',
                    border: 'none',
                    borderRadius: 10,
                    fontWeight: 600
                }}
            >
                Rozpocznij egzamin
            </button>
        </div>
    );
}
